import React from 'react'
import { useTranslation } from 'react-i18next'

import Link from '@material-ui/core/Link'
import Tooltip from '@material-ui/core/Tooltip'
import Typography from '@material-ui/core/Typography'
import makeStyles from '@material-ui/core/styles/makeStyles'

import { useSearchTranslation } from 'src/components/search/utils'
import { CatalogItemProps } from 'src/contexts/discovery'

const useStyles = makeStyles((theme) => ({
  row: {
    display: 'grid',
    gap: theme.spacing(4),
    gridTemplateColumns: '200px 1fr',
    hyphens: 'auto',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
    wordBreak: 'break-word',
    alignItems: 'start',
  },
  link: {
    cursor: 'pointer',
    textDecoration: 'underline',
    width: 'fit-content',
  },
  linkContainer: {
    display: 'flex',
  },
}))

interface ContentEntryProps {
  catalog: CatalogItemProps
  field: keyof CatalogItemProps
}

export function ContentEntry(props: Readonly<ContentEntryProps>) {
  const cls = useStyles()
  const { catalog, field } = props

  const { searchT } = useSearchTranslation()
  const { t } = useTranslation()
  const isExternalLink = field.includes('catalog-external-url')

  const renderTextualRow = () => {
    return Array.isArray(catalog[field])
      ? catalog[field].join(', ')
      : catalog[field]
  }

  const renderLinkRow = () => {
    return (catalog[field] as string[]).map((entry) => (
      <Tooltip
        title={t('catalog.tooltip')}
        key={entry}
        className={cls.linkContainer}
      >
        <Link
          className={cls.link}
          target="_blank"
          href={entry}
          rel="noreferrer"
          tabIndex={0}
        >
          {entry}
        </Link>
      </Tooltip>
    ))
  }

  return (
    <div key={field} className={cls.row}>
      <Typography variant="body2">
        {searchT('data', field, '__field__')}
      </Typography>
      <Typography component={'span'} variant="body1">
        {isExternalLink ? renderLinkRow() : renderTextualRow()}
      </Typography>
    </div>
  )
}
